import { useEffect, useState } from "react";
import "./conversation.scss";
import { makeRequest } from "../../axios";
import { AuthContext } from "../../context/authContext";
import { useContext } from "react";
import { getImageUrl } from "../../utils/getImageUrl";

const Conversation = ({ conversation, currentUser }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const friendId = conversation.find((m) => m !== currentUser.id);

    //. get ID's of friends you have conversations with
    const getUser = async () => {
      try {
        const res = await makeRequest.get("/users/find/" + friendId);
          setUser(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    getUser();
  }, [currentUser, conversation]);

  return (
    <div className="conversation">
      <img 
        src={
          user?.profilePicture
            ? getImageUrl("profile", user.profilePic)
            : "/defaultProfile.jpg"
        }
        alt=""
      /> 
      <span>{user?.name}</span>
    </div>
  );
};

export default Conversation;
